import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Output,
  inject
} from '@angular/core';
import { Trade } from '@approot/models';
import {
  AgGridService,
  LegService,
  StrategyDetailService,
  TradesCaptureService
} from '@approot/services';
import { GridApi, SideBarDef, ValueFormatterParams } from 'ag-grid-community';
import dayjs from 'dayjs';

@Component({
  selector: 'app-load-trade-versions',
  templateUrl: './load-trade-versions.component.html',
  styleUrls: ['./load-trade-versions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadTradeVersionsComponent {
  @Output() public returnToMenu = new EventEmitter<true>();
  public tradeId = '';
  public state: '' | 'LOADING' | 'DONE' = '';
  public rowData: Trade[] = [];
  public showMenu = true;
  public gridApi: GridApi;
  public sideBarDef: SideBarDef;
  public columnDefs: any = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      field: 'timestamp',
      headerName: 'Timestamp',
      valueFormatter: this.dateFormatter
    },
    {
      field: 'user',
      headerName: 'User'
    },
    {
      field: 'action',
      headerName: 'Action'
    }
  ];
  public selectedLoadedTrades: Trade[];
  private strategyDetailService = inject(StrategyDetailService);

  constructor(
    private agGridService: AgGridService,
    private tradesCaptureService: TradesCaptureService,
    private changeRef: ChangeDetectorRef,
    private legService: LegService
  ) {
    this.sideBarDef = this.agGridService.sideBarDef;
  }

  public loadTrades() {
    // only load the trades that have been selected in the grid
    this.strategyDetailService.setTabTradingMode(true);
    this.selectedLoadedTrades.forEach((loadedTrade: Trade) => {
      this.strategyDetailService.addLegToStructuringScreen(
        loadedTrade.trade.productType,
        false,
        loadedTrade.trade,
        true
      );
    });
  }

  public onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  public onSelectionChanged() {
    this.selectedLoadedTrades = this.gridApi.getSelectedRows();
  }

  public loadTradeRecords() {
    if (this.tradeId.length) {
      this.state = 'LOADING';
      this.tradesCaptureService
        .getUserInfoRequest({
          task: 'loadTradeRecords',
          tradeId: this.tradeId
        })
        .subscribe({
          next: (response: { items: Trade[] }) => {
            this.rowData = response.items;
            this.state = 'DONE';
            this.showMenu = false;
            this.changeRef.markForCheck();
          },
          error: () => {
            this.state = '';
            this.changeRef.markForCheck();
          }
        });
    }
  }

  public goBack() {
    this.returnToMenu.emit(true);
  }

  private dateFormatter(params: ValueFormatterParams) {
    return params.value
      ? dayjs(params.value).format('D MMM YYYY hh:mm:ss')
      : '';
  }

  private eventAction(params: ValueFormatterParams) {
    return params.data.event?.action || '';
  }

  private eventEmail(params: ValueFormatterParams) {
    return params.data.event?.userEmail || '';
  }
}
